/** @format */

import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PanToolIcon from "@mui/icons-material/PanTool";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import LineWeightIcon from "@mui/icons-material/LineWeight"; // thickness
import FormatPaintIcon from "@mui/icons-material/FormatPaint"; // fill
import ColorLensIcon from "@mui/icons-material/ColorLens"; // color
import { TbRadiusBottomLeft } from "react-icons/tb"; // radius
import { handleShapeToggleButton } from "../../../../store/reducers/pdfeditor/toolsModificationSlice";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import {
  deleteCoordinate,
  updateCoordinate,
} from "../../../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import ThicknessShape from "./ThicknessShape";
import RotateShape from "./RotateShape";
import ColorShape from "./ColorShape";
import { MuiColorInput } from "mui-color-input";
import { debounce } from "lodash";
import { modifiedCoordinateFunc } from "../../../../store/reducers/pdfeditor/pdfAddedRemovedCoordSlice";
function ToolBarShape({ position, coordinate, setSelectedBoxId }) {
  const dispatch = useDispatch();
  const { shapeToggleButton } = useSelector((state) => state.toolsModification);
  const { currVariable, dragToggleButton } = useSelector(
    (state) => state.toolsModification
  );
  const { coordinates } = useSelector((state) => state.pdfCoordinates);
  console.log("currvariable in toolbar shape", currVariable);
  const [activeShapeFeature, setActiveShapeFeature] = useState({
    thickness: false,
    rotate: false,
    color: false,
  });
  const [shapeChanges, setShapeChanges] = useState({
    color: "rgba(0,0,0,1)",
    rotate: "0",
    thickness: "1px",
  });

  const handleColorChange = useCallback(
    debounce((color) => {
      console.log("color in debounce is", color);
      dispatch(
        updateCoordinate({
          id: currVariable?.variable,
          newValue: {
            color: color,
          },
        })
      );
      setShapeChanges({ ...shapeChanges, color: color });
    }, 300), // Adjust the debounce delay as needed
    [dispatch, currVariable?.id, currVariable?.variable]
  );

  const findRemovedCoord = (id) => {
    const removedCoord = coordinates.find((item) => item.id === id);
    if (removedCoord) {
      dispatch(modifiedCoordinateFunc({ ...removedCoord, action: "removed" }));
    }
  };
  const handleDeleteVariable = (id) => {
    dispatch(deleteCoordinate(id));
    findRemovedCoord(id);
  };

  const toggleBox = (boxName) => {
    setActiveShapeFeature((prevState) => {
      const newState = {
        thickness: false,
        rotate: false,
        color: false,
      };
      newState[boxName] = !prevState[boxName];
      return newState;
    });
  };

  return (
    <div
      style={{
        position: "absolute",
        left: `${position.prex}px`,
        top: `${position.prey - 38}px`,
        zIndex: 4,
      }}
    >
      <div style={{ position: "absolute", top: "-40px" }}>
        {activeShapeFeature.thickness && <ThicknessShape />}
        {activeShapeFeature.rotate && <RotateShape />}
        {/* {activeShapeFeature.color && (
          <ColorShape settedBoxHeight={settedBoxHeight} />
        )} */}
        {activeShapeFeature.color && (
          <MuiColorInput
            format='rgb'
            style={{
              position: "relative",
              left: "112px",
              top: "-16px",
              // height: "35px",
              width: "180px",
              background: "white",
              borderRadius: "5px",
              width: "52px",
            }}
            value={coordinate?.color || "rgba(0,0,0,1)"}
            onChange={handleColorChange}
          />
        )}
      </div>
      <div
        style={{
          display: "flex",
          border: "1px solid #1976d2",
          background: "#fff",
          borderRadius: "5px",
          height: "38px",
          boxShadow: "0 0 10px 1px #1976d2",
        }}
      >
        {/* Drag Box */}
        <Tooltip title={`Toggle Drag`} placement='bottom'>
          <PanToolIcon
            // onClick={() => handleDragToggle()}
            onClick={() => setSelectedBoxId(null)}
            sx={{
              borderRadius: "5px",
              color: "#1976d2",
              padding: "7px",
              background: "white",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
          />
        </Tooltip>

        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div>
        {/* Thickness Box */}
        <Tooltip title={`Thickness`} placement='bottom'>
          <LineWeightIcon
            // onClick={() => handleDragToggle()}
            onClick={() => toggleBox("thickness")}
            sx={{
              borderRadius: "5px",
              color: "#1976d2",
              padding: "7px",
              background: "white",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
          />
        </Tooltip>

        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div>
        {/* Fill Box */}
        {/* <Tooltip title={`Fill`} placement="bottom">
          <FormatPaintIcon
            // onClick={() => handleDragToggle()}
            onClick={() => setSelectedBoxId(null)}
            sx={{
              borderRadius: "5px",
              color: "#1976d2",
              padding: "7px",
              background:  "white",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
          />
        </Tooltip>

        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div> */}
        {/* Rotate Left */}
        <Tooltip title={`Rotate`} placement='bottom'>
          <RotateLeftIcon
            // onClick={() => handleDragToggle()}
            onClick={() => toggleBox("rotate")}
            sx={{
              borderRadius: "5px",
              color: "#1976d2",
              padding: "7px",
              background: "white",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
          />
        </Tooltip>

        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div>

        {/* color Box */}
        <Tooltip title={`Color`} placement='bottom'>
          <ColorLensIcon
            // onClick={() => handleDragToggle()}
            onClick={() => toggleBox("color")}
            sx={{
              borderRadius: "5px",
              color: "#1976d2",
              padding: "7px",
              background: "white",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
          />
        </Tooltip>

        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div>
        {/* *********Delete Box********* */}
        <Tooltip title={`Delete`} placement='bottom'>
          <DeleteIcon
            onClick={() =>
              handleDeleteVariable(coordinate?.id || coordinate?.variable)
            }
            sx={{
              borderRadius: coordinate?.color ? "5px" : "5px",
              color: "#1976d2",
              padding: "7px",
              background: "white",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
          />
        </Tooltip>
      </div>
    </div>
  );
}

export default ToolBarShape;
